import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171E36",
      "fill-rule": "evenodd",
      d: "M17.256 2.744a.833.833 0 0 1 0 1.179l-5 5a.833.833 0 1 1-1.179-1.179l5-5a.833.833 0 0 1 1.179 0ZM2.744 17.256a.833.833 0 0 1 0-1.179l5-5a.833.833 0 0 1 1.179 1.179l-5 5a.833.833 0 0 1-1.179 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171E36",
      "fill-rule": "evenodd",
      d: "M11.667 3.333c0-.46.373-.833.833-.833h4.167a.833.833 0 0 1 0 1.667H12.5a.833.833 0 0 1-.833-.834ZM8.333 16.667c0 .46-.373.833-.833.833H3.333a.833.833 0 0 1 0-1.667H7.5c.46 0 .833.373.833.834Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171E36",
      "fill-rule": "evenodd",
      d: "M16.667 2.5c.46 0 .833.373.833.833V7.5a.833.833 0 1 1-1.667 0V3.333c0-.46.373-.833.834-.833ZM3.333 17.5a.833.833 0 0 1-.833-.833V12.5a.833.833 0 0 1 1.667 0v4.167c0 .46-.373.833-.834.833Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MapOpen"}) } }